import React, { useState, useEffect } from "react";
import { baseUrl } from "../../helpers/constants";
import useWindowSize from "../../helpers/useWindowSize";
import { ImageSwatch, Label, SwatchPicker } from "@fluentui/react-components";
import { ILuebOption } from "../../Models/ILuebOption";

interface IGearboxSelectionProps {
  selectedGearboxKey: string;
  onGearboxSelectionChanged: any;
  schraubfall: string;
}

function GearboxSelection(props: IGearboxSelectionProps) {
  const defChoiceGroup: ILuebOption[] = [];
  const [selectedGearboxKey, setSelectedGearboxKey] = useState("");
  const [gearboxOptions, setGearboxOptions] = useState(defChoiceGroup);

  useEffect(() => {
    setSelectedGearboxKey(props.selectedGearboxKey);
  }, [props.selectedGearboxKey]);

  const windowSize = useWindowSize();

  const imageSize = windowSize.width > 500 ? 230 : 100;

  const Standard_FL_G: ILuebOption = {
    key: "Standard_FL_G",
    icon: `${baseUrl}/IMAGES/GEARBOX/STANDARD_FL_G_250X250.PNG`,
    text: "L.SP3 access",
  };

  const Inline_FL_G: ILuebOption = {
    key: "Inline_FL_G",
    icon: `${baseUrl}/IMAGES/GEARBOX/INLINE_FL_G_250X250.PNG`,
    text: "L.SP3 access inline",
  };

  const LSP3angle: ILuebOption = {
    key: "Winkelkopf",
    icon: `${baseUrl}/IMAGES/GEARBOX/WINKELKOPF_250X250.PNG`,
    text: "L.SP3 angle",
  };

  const LSP3accessStraight: ILuebOption = {
    key: "Axial_Abtrieb",
    icon: `${baseUrl}/IMAGES/GEARBOX/AXIAL_ABTRIEB_250X250.PNG`,
    text: "L.SP3 access straight",
  };

  const Standard_FL_O: ILuebOption = {
    key: "Standard_FL_O",
    icon: `${baseUrl}/IMAGES/GEARBOX/STANDARD_FL_O_250X250.PNG`,
    text: "L.SP3 access",
  };

  const Inline_FL_O: ILuebOption = {
    key: "Inline_FL_O",
    icon: `${baseUrl}/IMAGES/GEARBOX/INLINE_FL_O_250X250.PNG`,
    text: "L.SP3 access inline",
  };

  // OFFEN
  // L.SP3 access
  // L.SP3 access inline

  useEffect(() => {
    const options: ILuebOption[] = [];

    switch (props.schraubfall) {
      case "schraube":
        options.push(Standard_FL_G);
        options.push(Inline_FL_G);
        options.push(LSP3angle);
        break;
      case "mutter":
        options.push(Standard_FL_G);
        options.push(Inline_FL_G);
        options.push(LSP3angle);
        break;
      case "holdndrive":
        options.push(Standard_FL_G);
        options.push(Inline_FL_G);
        options.push(LSP3angle);
        options.push(LSP3accessStraight);
        break;
      case "rohrleitung":
        options.push(Standard_FL_O);
        options.push(Inline_FL_O);
        break;
      default:
        break;
    }
    setGearboxOptions(options);
  }, [props.schraubfall, windowSize]);

  useEffect(() => {
    if (gearboxOptions.length > 0) {
      if (!props.selectedGearboxKey || props.selectedGearboxKey == "") {
        const firstOption = gearboxOptions[0];
        setSelectedGearboxKey(
          typeof firstOption.key == "string" ? firstOption.key : "",
        );
        props.onGearboxSelectionChanged({
          key: firstOption.key,
          text: firstOption.text,
        });
      }
    }
  }, [gearboxOptions]);

  return (
    <div style={{ margin: "15px" }}>
      <SwatchPicker
        selectedValue={selectedGearboxKey}
        onSelectionChange={(ev, val) => {
          setSelectedGearboxKey(val.selectedValue);
          var imageText = gearboxOptions.find((x) => val.selectedValue == x.key)
            ?.text;
          props.onGearboxSelectionChanged({
            key: val.selectedValue,
            text: imageText,
          });
        }}
      >
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {gearboxOptions.map((item) => {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "2px",
                }}
              >
                <ImageSwatch
                  style={{
                    width: 230,
                    height: 230,
                  }}
                  value={typeof item.key == "string" ? item.key : ""}
                  src={item.icon ? item.icon : ""}
                />
                <Label style={{ marginTop: "5px" }} weight="semibold">
                  {item.text}
                </Label>
              </div>
            );
          })}
        </div>
      </SwatchPicker>
    </div>
  );
}

export default GearboxSelection;
